import { useEffect } from "react";
import { useLocation } from "react-router";
import { trackPageview } from "../analytics";

/**
 * Sendet bei jedem Routenwechsel einen Pageview an Umami.
 * Die interne Admin-Oberfläche wird dabei nicht erfasst.
 */
export const usePageviewTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) {
      return;
    }

    trackPageview();
  }, [location.pathname, location.search]);
};
